<template>
  <div class="col-md-5 !tw-mx-auto login-wrapper second-factor">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>

    <form>
      <Card class="card-login">
        <h3>{{ $t('forms.secondFactor.secondFactorTitle') }}</h3>
        <div class="inputs">
          <div class="title-input">
            {{ formInfo.title }}
          </div>
          <TfaCodeInput
            :key="formInfo.typeInput"
            v-model="token"
            auto-focus
            :input-type="formInfo.typeInput"
            :fields="formInfo.typeInput === 'text' ? 8 : 6"
            :field-width="formInfo.typeInput === 'text' ? 35 : 46.6"
            :field-height="formInfo.typeInput === 'text' ? 34 : 34"
            @complete="verify"
          />
          <div class="text-danger tw-text-right mt-8">
            <span v-show="validation">{{ $t(`forms.validation.${formInfo.typeInput === 'text' ? 'bcfa' : 'sfa'}`) }}</span>
          </div>
        </div>
        <span
          class="backup-switch"
          @click="handlerType"
        >{{ formInfo.switchLink }}</span>
        <div class="!tw-flex pb-header tw-justify-between tw-items-center">
          <button
            class="btn btn-primary btn-sm !tw-w-full"
            @click.prevent="$router.push('/logout')"
          >
            &lt; {{ $t('customReports.back') }}
          </button>
        </div>
        <a
          class="!tw-block tw-text-center trouble-get"
          :href="contactsUrl"
          target="_blank"
        > {{ $t('forms.secondFactor.secondFactorText') }}? </a>
      </Card>
    </form>
  </div>
</template>

<script>
import _ from '@/lib/lodash';
import TfaCodeInput from '@/components/ui/TfaCodeInput.vue';

export default {
  components: {
    TfaCodeInput,
  },
  data() {
    return {
      validation: false,
      token: '',
      typeCode: 'ga',
    };
  },

  computed: {
    formInfo() {
      if (this.typeCode === 'ga') {
        return {
          title: this.$t('profile.disableSecondFactor.token'),
          switchLink: this.$t('profile.secondFactor.enter_bc'),
          typeInput: 'number',
        };
      }
      return {
        title: this.$t('profile.secondFactor.bc'),
        switchLink: this.$t('profile.secondFactor.ecfa'),
        typeInput: 'text',
      };
    },

    logo() {
      return this.$config.layout.logoFull;
    },
    contactsUrl() {
      const defaultUrl = `https://${this.$config.frontPageUrl}/contact-us`;
      return _.get(this.$store.state, 'misc.miscSettings.contacts.contact_us_form', defaultUrl);
    },
  },
  methods: {
    handlerType() {
      this.validation = false;
      this.typeCode = this.typeCode === 'ga' ? 'bc' : 'ga';
      this.token = '';

      // setTimeout(() => document.getElementsByClassName('react-code-input')[0].children[0].focus());
    },

    verify() {
      this.$request
        .post('auth/totp', { token: this.token, trust: true })
        .then((res) => {
          if (!res.data.payload.result) {
            this.validation = true;
          } else {
            this.$router.push(this.$config.mainScreen);
            this.$store.dispatch('loginSuccess');
            this.$eventBus.$emit('login');
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.second-factor {
  .title-input {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .backup-switch {
    display: inline-block;
    border-bottom: 1px dashed var(--color-text-green);
    color: var(--color-text-green);
    margin-bottom: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .login-page-link {
    font-size: 16px !important;
    &:hover {
      text-decoration: underline !important;
      cursor: pointer;
    }
  }
  .inputs {
    margin-bottom: 16px !important;
    margin-top: 24px;
    .input {
      display: flex;
      align-items: center;
      .react-code-input {
        input {
          // width: 100% !important;
          justify-content: flex-start !important;
          border: 1px solid #d9d9d9 !important;
          caret-color: #000;
          font-size: 26px;
          border-right: 0px !important;
          font-family: 'Open Sans';
          color: #303634;
          &:first-child {
            border-radius: 8px 0 0 8px !important;
          }
          &:last-child {
            border-radius: 0 8px 8px 0 !important;
            border-right: 1px solid #d9d9d9 !important;
          }
          &:focus {
            border: 1px solid var(--active-color) !important;
            border-right: 0px !important;
            &:last-child {
              border-right: 1px solid var(--active-color) !important;
            }
            & + input {
              border-left: 1px solid var(--active-color) !important;
            }
          }
        }
      }
    }
  }
  .text-danger {
    margin-top: 8px !important;
  }
  .btn {
    margin: 0px 1px 7px !important;
    padding: 13px 13px 14px !important;
  }
  .btn-outline-primary {
    width: 100px;
  }
  .btn-primary {
    width: 164px;
  }
  .trouble-get {
    color: #408ce4;
    font-size: 12px !important;
    font-weight: 600;
  }

  @media (max-width: 460px) {
    margin-top: 4vh !important;
    min-width: 290px !important;
    form {
      position: absolute;
      width: calc(100% + 52px);
      left: 0;
      top: 80px;
      margin-left: -26px;
    }
    .card-login {
      height: 1000px;
      border-radius: 0 !important;
      padding: 16px 35px !important;
    }
    .btn-box {
      .btn-outline-primary {
        min-width: 100px;
      }
      .btn-primary {
        width: 100%;
        margin-left: 10px !important;
      }
    }
  }
  @media (max-width: 760px) {
    .inputs {
      .input {
        width: 100% !important;
        justify-content: flex-start !important;
        align-items: flex-start;
        .react-code-input {
          input {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
